//====================================================
// IMPORT POLYFILL FOR IE
//====================================================
import 'babel-polyfill'

//====================================================
// IMPORT BASE LIBS FOR VUE APP
//====================================================
import Vue from 'vue'
import App from './App.vue'
import Axios from 'axios'
import { router } from './router'
import store from './store'
import i18n from './i18n'
import globalComponents from './components/global'

//====================================================
// IMPORT LODASH FOR JS HELPERS
//====================================================
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })

//====================================================
// SET BASE APP LOCALE
//====================================================
const lang = localStorage.getItem('locale')
if (lang == null){
    localStorage.setItem('locale', 'fr')
}else{
    i18n.locale = lang
}

//====================================================
// IMPORT DAYJS FOR DATES
//====================================================
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/fr'
import 'dayjs/locale/en'

dayjs.extend(relativeTime);
dayjs.locale(localStorage.getItem('locale'))
Vue.prototype.$date = dayjs

//====================================================
// VUELIDATE PLUGIN FORM VALIDATION
//====================================================
import VeeValidate from 'vee-validate';
import FormValidationsFr from '@/locales/validations.fr'
import FormValidationsEn from '@/locales/validations.en'
Vue.use(VeeValidate, {
    classes: true,
    i18nRootKey: 'validations', // customize the root path for validation messages.
    i18n,
    dictionary: {
        fr: FormValidationsFr,
        en: FormValidationsEn
    }
});

//====================================================
// VUELIDATE PLUGIN FORM VALIDATION
//====================================================
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)

//====================================================
// AXIOS AUTH CONFIG (JWT)
//====================================================

// Set API END POINT
Axios.defaults.baseURL = process.env.VUE_APP_AXIOS_BASE_URL;
// Set var for base sight API URL for stores
store.sightApiBaseUrl = `iapp_api/${process.env.VUE_APP_AXIOS_API_ID}/v1/sight/`


// Add language param on Axios requests
Axios.interceptors.request.use((request) => {
        const lang = localStorage.getItem('locale')
        if (request.params){
            request.params['language'] = lang
        }else{
            request['params'] = {language: lang}
        }
        return request;
    }
);
// Add 401 interceptor for Axios requests
Axios.interceptors.response.use((response) => { return response; }, (error) => {
    console.log(error)
    if (401 === error.response.status) {
        console.log("Unauthentified")
        localStorage.removeItem('jwt')
        localStorage.removeItem('user')
        router.push('/login')
        return Promise.reject(error);
    } else if (403 === error.response.status) {
        console.log('access forbiden for account')
        router.push('/unautorized')
    } else {
        return Promise.reject(error);
    }
});

//====================================================
// BASE VUE CONFIG
//====================================================
Vue.config.productionTip = false
// Import ui global components
globalComponents.forEach( component => { Vue.component(component.name, component) } )

// Import App layouts components
import layoutUser from '@/components/layouts/layoutUser.vue'
import layoutGuest from '@/components/layouts/layoutGuest.vue'
Vue.component('layoutUser', layoutUser)
Vue.component('layoutGuest', layoutGuest)

// Import slider input component
import VueSlider from 'vue-slider-component'
Vue.component('VueSlider', VueSlider)

// Import globals scss files and load variables for vue
import '@/assets/scss/main.scss';

//====================================================
// INIT APP
//====================================================

// Set and control access befor mount app
//---------------------------------------------------
const jwt = localStorage.getItem('jwt')
if (jwt) {
    // Get user data and store in local storage
    Axios.defaults.headers.common['Authorization'] = "Bearer " + jwt
    Axios.get(store.sightApiBaseUrl + "profile/get_access").then(resp => {

        const account = resp.data
        localStorage.setItem('account', JSON.stringify(account))

        // Mount application if no errors on user data and access
        new Vue({router,store,i18n,render: h => h(App)}).$mount('#app')

    }).catch(err => {
        console.log("Get access error", err.response)
        new Vue({router,store,i18n,render: h => h(App)}).$mount('#app')
    })
}else{
    new Vue({
        router,
        store,
        i18n,
        render: h => h(App)
    }).$mount('#app')
}
